import React, { useState, useEffect, useRef } from "react";
import StripeSvg from '../svgs/StripeSvg';
import { numberWithCommas } from '../utils/util';
import { server_ip } from "../config";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { fetchProductById } from '../services/products';
import { validateuserId } from "../services/users";


const HIDE_QTY_LIST= [
  '68c7b65715ff23992e9029aa','68c7b87515ff23992e9029ab','68c7b8ac15ff23992e9029ac','68c7b8ec15ff23992e9029ad','68e8e70bc251ddc20021b5f7'
]
function ProductDisplay(props) {
  const [quantity, setquantity] = useState(1)
  const [searchParams, setSearchParams] = useSearchParams();
  const userId = searchParams.get('userid') || null;
  const [isUserValid, setIsUserValid] = useState(false);

  function getPrice(){
    let membership = isUserValid?.data?.membership||'普通用戶'
    let isMemberShipExpired = (isUserValid?.data?.membershipExpireDate) && (new Date(isUserValid?.data?.membershipExpireDate).getTime() < Date.now())
    if(isMemberShipExpired){membership='普通用戶'}
    let price = 0
    switch (membership) {
      case '普通用戶':
        price = data?.price || 0
        break;
      case '星級會員':
        price = data?.price2 || data?.price || 0
        break;
      case '尊享會員':
        price = data?.price3 || data?.price2 || data?.price || 0
        break;
      default:
        price = data?.price || 0
        break;
    }
    return price
  }
  function total() { return quantity * getPrice() }
  function add() { setquantity(s => s + 1) }
  function minus() { setquantity(s => s - 1 < 1 ? 1 : s - 1) }
  const navigate = useNavigate();
  const location = useLocation();
  const navigateTo = (str) => () => { navigate(str) }
  let { id } = useParams()
  const [data, setData] = useState({})

  async function fetchData() {
    let result = await fetchProductById(id)
    if (result?.result) {
      setData(result?.result)
    }
  }
  async function validUserId(userId) {
    let result = await validateuserId(userId)
    setIsUserValid(result?.result || false)
  }
  useEffect(() => {
    if(userId&& userId.length === 24){
      validUserId(userId)
    }
  },[userId])
  useEffect(() => {
    if (id && id.length === 24)
      fetchData()
  }, [id])

  const handleSubmit = async (event) => {
    event.preventDefault()
    if(data.isDisplayOnly){ alert('此商品僅供展示，無法購買'); return }
    if(getPrice()<=0){ alert('此商品價格有誤，請聯絡我們'); return }
    let membership = isUserValid?.data?.membership||'普通用戶'
    let isMemberShipExpired = (isUserValid?.data?.membershipExpireDate) && (new Date(isUserValid?.data?.membershipExpireDate).getTime() < Date.now())
    if(isMemberShipExpired){membership='普通用戶'}
    if(data.isNormalUserDisabled && membership==='普通用戶'){ alert('此商品僅供會員購買，請先升級會員'); return }
    if(data.isStarUserDisabled && membership==='星級會員'){ alert('此商品僅供尊享會員購買，請先升級會員'); return }
    if(data.isPremiumUserDisabled && membership==='尊享會員'){ alert('此商品無法購買，請聯絡我們'); return }

    const formData = new FormData(event.target);

    // Add custom attributes to the form data
    formData.append('jwt', props.token?.token || 'null');
    formData.append('userid', userId || '');
    formData.append('products', JSON.stringify([
      { name: data?.name || 'No item name', productId: id, quantity },
    ]));

    // Create a new FormData object with modified data
    const modifiedFormData = formData; // You can modify this as needed

    // Create a new form element
    const newForm = document.createElement('form');
    newForm.action = event.target.action; // Keep the original form action
    newForm.method = 'post';

    // Append each field to the new form
    for (let pair of modifiedFormData.entries()) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      newForm.appendChild(input);
    }

    // Append the new form to the document body and submit it
    document.body.appendChild(newForm);

    newForm.submit()
  }


  if(!data._id){
    return (
      <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
        <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[24px]">
          您請求的物品不再有效
        </div>
      </div>
    )
  }
  if((!isUserValid) || (!userId)){
    return (
      <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
        <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[24px]">
          您的帳號尚未登入
        </div>
        <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[16px]">
          請先登入或註冊帳號
        </div>
        {/* <div onClick={navigateTo('/login')} className="font-bold text-[#938474] my-[64px] cursor-pointer" style={{ border: '1px solid #938474', borderRadius: 8, padding: '12px 24px' }}>
          登入/註冊
        </div> */}
      </div>
    )
  }
  return (

    <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">

      <div className="max-w-[600px] w-[100%] font-bold text-[16px] flex flex-row items-center gap-[8px]">
        <div className="text-[16px] font-bold">購買者資訊: </div>
        {isUserValid.mobile?`手機號碼- ${isUserValid.mobile}`
        :isUserValid.email? `電子郵件- ${isUserValid.email}`
        :` unknown`}
      </div>
      <div className="max-w-[600px] w-[100%] mt-[24px] font-bold text-[24px]">
        {data?.name || 'No item name'}
      </div>

      {(data?.hero||data?.thumbnail)&&<div className="max-w-[400px] w-[100%] my-[16px]">
        <img src={data?.hero||data?.thumbnail || ''} alt={data?.name || 'No item name'} className="w-full h-auto" />
      </div>}

      {HIDE_QTY_LIST.includes(id)||<div className="max-w-[600px] w-[100%] mb-[8px] font-bold">
        價格: ${getPrice()}
      </div>}
      {HIDE_QTY_LIST.includes(id)||<div className="max-w-[600px] w-[100%] mb-[8px] font-bold flex flex-row items-center gap-[12px]">
        數量:
        <div onClick={minus} className="w-[24px] h-[24px] bg-[#938474] text-[white] cursor-pointer items-center justify-center flex rounded">-</div>
        {quantity}
        <div onClick={add} className="w-[24px] h-[24px] bg-[#938474] text-[white] cursor-pointer items-center justify-center flex rounded">+</div>
      </div>}
      
      <div className='max-w-[600px] w-[100%] text-[16px] font-bold mt-[24px]'>
        付款方式
        <StripeSvg />
      </div>

      {isUserValid&&<form action={`${server_ip}/api/stripe/create-checkout-session`} className="my-[32px]" method="POST" onSubmit={handleSubmit}>
        <button type="submit" className="font-bold text-[#938474] my-[16px] select-none" style={{ border: '1px solid #938474', borderRadius: 8, padding: '12px 24px' }}>
          前往付款
        </button>
      </form> }

      {/* <div className='max-w-[600px] w-[100%] text-[16px] font-bold mt-[64px]'>
      條款細則
    </div>
    <div className='max-w-[600px]  w-[100%] mb-[64px] text-[10px]'>
      使用許可：使用者必須同意遵守使用條款和許可協議，並確保自己符合相關法律和法規。使用者內容：使用者在T.gather上發佈的任何內容，包括評論、評分、回饋等，應符合相關法律法規，並不得侵犯他人的權利或違反任何專利、版權、商標或其他知識產權。付款和訂閱：如果漫畫App提供付費服務或訂閱，使用者在使用這些服務時需按照相應的價格和條件支付費用。使用者應詳細閱讀相關付款和訂閱細則，包括自動續訂和退款政策。用戶帳戶：使用者可能需要創建一個個人帳戶，並確保帳戶信息的準確性和保密性。使用者應對他們的帳戶和密碼負有責任，並須對該帳戶的所有活動負責。服務限制：漫畫App可能設定某些限制，例如地區限制、年齡限制等。使用者應遵守這些限制，並確保自己的使用符合相關規定。取消和終止：漫畫App可能有權隨時終止或取消使用者的訪問權限，如果使用者違反了使用條款或相關規定。免責聲明：漫畫App可能對因使用App而導致的任何損失、損害或問題不承擔責任。使用者應自行承擔使用App的風險。
    </div> */}

      <div className="flex flex-col max-w-[600px]">
        <div className="w-full  w-full flex flex-col gap-[8px] mt-[24px]">
          <div className='w-full flex flex-row justify-between items-center gap-[24px]'>
            <div className="font-bold text-[24px]">{data?.name || 'No item name'}</div>
            <div className="f-14-normal">HK${getPrice()}</div>
          </div>
          <div className="flex flex-row justify-start gap-[8px] items-center">
            <div className="text-[#697386] f-12-normal">數量</div>
            <div className="text-black f-12-normal">{quantity}</div>
            {/* <DownArrow/> */}
          </div>
        </div>
        <div className="w-full flex flex-col items-end text-[14px] text-black mt-[32px]">
          <div className="w-full  flex flex-row justify-between pb-[12px]" style={{ maxWidth: '100%', borderBottom: '1px solid rgba(60, 66, 87, 0.12)' }}>
            <div>小計</div>
            <div>HK$ {numberWithCommas(total())}</div>
          </div>
          <div className="w-full  flex flex-row justify-between pt-[12px]" style={{ maxWidth: '100%' }}>
            <div>應付總額</div>
            <div>HK$ {numberWithCommas(total())}</div>
          </div>
        </div>
      </div>

      {/* {isUserValid&&<form action={`${server_ip}/api/stripe/create-checkout-session`} className="my-[64px]" method="POST" onSubmit={handleSubmit}>
        <button type="submit" className="font-bold text-[#938474] my-[16px] select-none" style={{ border: '1px solid #938474', borderRadius: 8, padding: '12px 24px' }}>
          前往付款
        </button>
      </form> } */}
        {/* <div onClick={navigateTo('/login')} className="font-bold text-[#938474] my-[64px] cursor-pointer" style={{ border: '1px solid #938474', borderRadius: 8, padding: '12px 24px' }}>
          登入/註冊
        </div> */}

    </div>
  )
}

const Message = ({ message }) => (
  <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
    <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[24px]">
      {message}
    </div>
  </div>
);

function App(props) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
  }, []);

  return message ? (
    <Message message={message} />
  ) : (
    <ProductDisplay token={props.token} />
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)